"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GasCostType = exports.FeeType = void 0;
var FeeType;
(function (FeeType) {
    FeeType["AXELAR_FEE"] = "Axelar fee";
    FeeType["GAS_RECEIVER_FEE"] = "Gas receiver fee";
    FeeType["BOOST_FEE"] = "Boost fee";
    FeeType["INTEGRATOR_FEE"] = "Integrator fee";
})(FeeType || (exports.FeeType = FeeType = {}));
var GasCostType;
(function (GasCostType) {
    GasCostType["EXECUTE_CALL"] = "executeCall";
})(GasCostType || (exports.GasCostType = GasCostType = {}));
//# sourceMappingURL=index.js.map